import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import CurrencyConverter from '../../CurrencyConverter';
import Link from '../../Link';
import messages from '../../../locale/messages';
import bt from '../../../components/commonStyle.css';
import s from './ViewPaymentQR.css';
import CommonTable from '../../CommonTable/CommonTable';
import CustomPagination from '../../CustomPagination/CustomPagination';
class ViewPaymentQR extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			currentPage: 1,
			searchKey: '',
			typing: false,
			typingTimeout: 0
		}
	}

	static defaultProps = {
		data: []
	};
	UNSAFE_componentWillReceiveProps(nextProps) {
		const { completed, loading } = nextProps;
		const { refetch } = this.props;
		if (completed && !loading) {
			refetch();
		}
	}

	paginationData = (currentPage) => {
		const { refetch } = this.props;
		let variables = { currentPage };
		this.setState({ currentPage });
		refetch(variables);
	}

	handleSearchChange = (e) => {
		const self = this;
		if (self.state.typingTimeout) {
			clearTimeout(self.state.typingTimeout);
		}
		setTimeout(function () {
			self.handleClick(e.target.value,);
		}, 1450)
		self.setState({
			searchKey: e.target.value,
			typing: false,
			typingTimeout: setTimeout(function () {
				self.handleClick(self.state.searchKey);
			}, 450)
		});
	}

	handleClick = (searchKey) => {
		const { refetch } = this.props;
		const { currentPage } = this.state;
		let variables = {
			currentPage: 1,
			searchKey: searchKey
		};
		this.setState({ currentPage: 1 });
		refetch(variables);
	}

	thead = () => {
		const { formatMessage } = this.props.intl;
		return [
			{ data: formatMessage(messages.reservationId) },
			{ data: 'QR ID' },
			{ data: 'Monto' },
			{ data: 'Moneda' },
			{ data: 'Nombre Original' },
			{ data: 'Voucher ID' },
			{ data: 'Descripción' },
			{ data: 'Fecha de Expiración' },
			{ data: 'Fecha de Transacción' },
			{ data: formatMessage(messages.status) },
			{ data: formatMessage(messages.createdDate) },
			{ data: formatMessage(messages.details) }
		]
	}

	tbody = (props) => {
		const { data: { getAllPaymentQR } } = props;
		const { formatMessage } = props.intl;

		console.log('porops4', getAllPaymentQR)

		return getAllPaymentQR?.map((item, key) => {
			return {
				id: key,
				data: [
					{ data: item?.reservationId },
					{ data: item?.qrId },
					{
						data: <CurrencyConverter
							amount={item.amount}
							from={item?.currency}
						/>
					},
					{ data: item?.currency },
					{ data: item?.originalName || '-' },
					{ data: item?.voucherId || '-' },
					{ data: item?.gloss || '-' },
					{
						data: item?.expirationDate ? moment(item?.expirationDate).format('DD-MM-YYYY h:mm A') : '-'
					},
					{
						data: item?.transactionDateTime ? moment(item?.transactionDateTime).format('DD-MM-YYYY h:mm A') : '-'
					},
					{
						data: item?.statusId == 2 ? 'Completado' : 'No Completado'
					},
					{
						data: item?.createdAt ? moment(item?.createdAt).format('DD-MM-YYYY h:mm A') : '-'
					},
					{
						data: <Link to={"/siteadmin/viewpayout/" + item?.reservationId + '/payout'} >
							<FormattedMessage {...messages.messageHistroyLabel} />
						</Link>
					}
				]
			}
		});
	}

	render() {
		const { data: { getAllPaymentQR, totalCount, currentPage } } = this.props;
		//const { currentPage } = this.state;
		const { formatMessage } = this.props.intl;


		return (
			<div className={cx(s.pagecontentWrapper, 'pagecontentAR')}>
				<CommonTable
					title={formatMessage(messages.payoutManagement)}
					thead={this.thead}
					tbody={() => this.tbody(this.props)}
					isSearch={false}
					handleSearch={(e) => this.handleSearchChange(e)}
				/>
				{
					getAllPaymentQR?.length > 0 &&
					<CustomPagination
						total={totalCount}
						currentPage={currentPage}
						defaultCurrent={1}
						defaultPageSize={5}
						change={this.paginationData}
						paginationLabel={formatMessage(messages.payoutsLabel)}
						isScroll
					/>
				}
			</div>
		)
	}
}

const mapState = (state) => ({
	completed: state.reservation.completed,
	loading: state.reservation.loading,
});

const mapDispatch = {};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(ViewPaymentQR)));